import { useEffect } from 'react';
import { useTracker } from './useTracker';
let hasSignupInitiatedBeenTrackedCache = false;
export function getHasSignupInitiatedBeenTracked() {
  return hasSignupInitiatedBeenTrackedCache;
}
export function setHasSignupInitiatedBeenTracked(value) {
  hasSignupInitiatedBeenTrackedCache = value;
}
export const useTrackSignupInitiated = (shouldTrackSignupInitiated = true) => {
  const Track = useTracker();
  const hasSignupInitiatedBeenTracked = getHasSignupInitiatedBeenTracked();
  useEffect(() => {
    if (!getHasSignupInitiatedBeenTracked() && shouldTrackSignupInitiated) {
      Track.signupInitiated();
      setHasSignupInitiatedBeenTracked(true);
    }
  }, [Track, hasSignupInitiatedBeenTracked, shouldTrackSignupInitiated]);
};